<template>
    <div style="background-color: white; width: 100%;">
      <img width="100%" v-if="type=='0'" src="https://yibaodata.oss-cn-beijing.aliyuncs.com/h5_img/assets/%E5%AE%9A%E5%88%B6%E6%96%B9%E6%A1%88-%E7%9B%8A%E5%B0%8F%E5%AE%9D.jpg">
      <img width="100%" v-else src="https://yibaodata.oss-cn-beijing.aliyuncs.com/h5_img/assets/%E5%AE%9A%E5%88%B6%E6%96%B9%E6%A1%88-%E5%BF%83%E6%99%BA%E5%AE%9D.jpg">

      <!--        <div style="display: flex; justify-content: space-between; align-items: center; padding: 20px; background-color: #F5FAFF;">
      &lt;!&ndash;            <div>&ndash;&gt;
      &lt;!&ndash;                <div style="color: #4E4E4E; font-size: 18px;">保障定制方案</div>&ndash;&gt;
      &lt;!&ndash;                <div style="color: #4E4E4E; font-size: 12px;">益宝-心智宝项目心智 障碍者保障平台</div>&ndash;&gt;
      &lt;!&ndash;            </div>&ndash;&gt;
                  <van-image width="100%" :src="require('@/assets/protectionBg.jpg')"/>
              </div>
              <div style="padding: 20px;">
                  <div style="display: flex; justify-content: stretch;">
                      <van-button color="linear-gradient(to right, #4587DD, #40B6F8)" style="flex:1; border-radius: 6px;" @click="gotoProductList">为我的家庭定制保障方案</van-button>
                  </div>
                  <div class="loveShareBox">
                      <div style="padding: 15px; display: flex; align-items: center; justify-content: center;">
                          <div style="width: 4px; height: 4px; border-radius: 2px; background-color: #1C7CF8;" />
                          <div style="font-weight: bold; margin: 0 10px;">定制案例</div>
                          <div style="width: 4px; height: 4px; border-radius: 2px; background-color: #1C7CF8;"/>
                      </div>
                      <van-image width="80px" height="80px" :src="require('@/assets/man.png')"/>
                      <div style="padding: 20px; font-size: 14px;">
                          家庭保障方案定制是我们目前正在筹备的服务，定制服务将于近期内正式上线，敬请各位家长朋友关注。如果您想提前了解相关信息，您可以长按下方二维码，咨询微信客服【心智小宝】相关事宜。
                      </div>
                      <van-image width="100px" height="100px" :src="require('@/assets/protectionQRCode.jpg')" style="margin-bottom: 10px;"/>
                  </div>
              </div>-->
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image, Button, Toast} from 'vant';
    import Cookies from "js-cookie";

    Vue.use(Image).use(Button).use(Toast);
    export default {
      name: "ProtectionScheme",
      data() {
        return {
          type: Cookies.get('type') || '0',
        }
      },
      methods: {
        gotoProductList() {
          // this.$router.push('/productList');
          // window.location.href = `${process.env.VUE_APP_SHARE_URL}/productList`
        }
      }
    }
</script>

<style scoped>
    .loveShareBox {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0px 2px 6px 0px rgba(219, 219, 219, 0.5);
        border-radius: 4px;
        margin-top: 20px;
    }
</style>
